module.exports = __webpack_public_path__ + "static/media/landing_runway_matrix.f0397ff3.png";